import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AdminLandingView from '@/views/AdminLandingView.vue'
// Справочники (ТЗ «Рабочие задачи» блок 6.2–6.5)
import RanksSettingsView from '@/views/settings/RanksView.vue'
import PositionsSettingsView from '@/views/settings/PositionsView.vue'
import StpnTypesSettingsView from '@/views/settings/StpnTypesView.vue'
import UserCategoriesSettingsView from '@/views/settings/UserCategoriesView.vue'
import VehicleTypesSettingsView from '@/views/settings/VehicleTypesView.vue'
import MealTypesSettingsView from '@/views/settings/MealTypesView.vue'
import CheckTypesSettingsView from '@/views/settings/CheckTypesView.vue'
import RoutineSettingsView from '@/views/settings/RoutineSettingsView.vue'
import PlanView from '@/views/chpo/PlanView.vue'
import Login from '../views/LoginView.vue'
import DecisionStartView from '@/views/chpo/DecisionStartView.vue'
import PersonnelListView from '@/views/chpo/PersonnelListView.vue'
import OrdersView from '@/views/chpo/OrdersView.vue'
import MapView from '@/views/chpo/MapView.vue'
import ForcesView from '@/views/chpo/ForcesView.vue'
import BriefView from '@/views/chpo/BriefView.vue'
import DailyScheduleView from '@/views/chpo/DailyScheduleView.vue'
import auth from '@/middlewares/auth.js'
import SectorSelectView from '@/views/chpo/SectorSelectView.vue'
import KpsMapView from '@/views/book/KpsMapView.vue'
import KpsPersonnelView from '@/views/book/KpsPersonnelView.vue'
import KpsOrdersView from '@/views/book/KpsOrdersView.vue'
import KpsCalendarView from '@/views/book/KpsCalendarView.vue'
import KpsOfficersWorkView from '@/views/book/KpsOfficersWorkView.vue'
import KpsInspectionsView from '@/views/book/KpsInspectionsView.vue'
import KpsDdMembersView from '@/views/book/KpsDdMembersView.vue'
import KpsPlanExtractView from '@/views/book/KpsPlanExtractView.vue'
import KpsRegimeViolationsView from '@/views/book/KpsRegimeViolationsView.vue'
import KpsBorderViolationsView from '@/views/book/KpsBorderViolationsView.vue'
import KpsBorderRegimeViolationsView from '@/views/book/KpsBorderRegimeViolationsView.vue'
import KpsGuardRulesViolationsView from '@/views/book/KpsGuardRulesViolationsView.vue'
import BsfpAttendanceView from '@/views/bsfp/BsfpAttendanceView.vue'
import BsfpScheduleView from '@/views/bsfp/BsfpScheduleView.vue'
import BsfpLiteratureView from '@/views/bsfp/BsfpLiteratureView.vue'
import VirPerformanceView from '@/views/vir/VirPerformanceView.vue'
import VirScheduleView from '@/views/vir/VirScheduleView.vue'
import MpoStarChartView from '@/views/mpo/MpoStarChartView.vue'
import KioskSurveyView from '@/views/mpo/KioskSurveyView.vue'
import MapSchemeView from '@/views/chpo/MapSchemeView.vue'
import TsogView from '@/views/tsog/TsogView.vue'
import WorkloadView from '@/views/chpo/WorkloadView.vue'
import AdminUsersView from '@/views/admin/AdminUsersView.vue'
import AdminDictionariesView from '@/views/admin/AdminDictionariesView.vue'
import { checkOrCreateChpoByDate } from '@/api/chpo'
import { checkOrCreateBookByDate } from '@/api/book'
import { computeChpoDate } from '@/api/chpo'
import { computeBookDate } from '@/api/book'

// Household views
import HouseholdDashboardView from '@/views/household/DashboardView.vue'
import HouseholdNomenclatureTypesView from '@/views/household/NomenclatureTypesView.vue'
import HouseholdNomenclaturesView from '@/views/household/NomenclaturesView.vue'
import HouseholdCounterpartiesView from '@/views/household/CounterpartiesView.vue'
import HouseholdWarehousesView from '@/views/household/WarehousesView.vue'
import HouseholdOperationsView from '@/views/household/OperationsView.vue'
import HouseholdExpiryView from '@/views/household/ExpiryDatesView.vue'
import HouseholdDepreciationView from '@/views/household/DepreciationView.vue'
import HouseholdTempStorageView from '@/views/household/TempStorageView.vue'
import HouseholdWeaponIssueView from '@/views/household/WeaponIssueView.vue'
import HouseholdStockReportView from '@/views/household/StockReportView.vue'
import HouseholdMovementReportView from '@/views/household/MovementReportView.vue'
import HouseholdStatementsView from '@/views/household/StatementsView.vue'
import HouseholdWarehouseServicePage from '@/views/household/WarehouseServicePage.vue'

const COMMON_TITLE = 'Title'
const CHPO_TITLE = 'Принятие решения на очередные сутки'
const CHPO_TITLE_I18N = 'routes.chpoStart'
const KPS_TITLE = 'Книга пограничной службы'
const KPS_TITLE_I18N = 'routes.kpsBook'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: 'Главная',
      headerTitleI18n: 'routes.home',
      headerLive: true,
    },
  },

  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      layout: 'auth',
      headerTitle: 'Вход',
      headerTitleI18n: 'routes.login',
      headerLive: false,
    },
  },

  // Landing суперпользователя — по ТЗ «Рабочие задачи» блок 7
  {
    path: '/admin-landing',
    name: 'admin-landing',
    component: AdminLandingView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: 'Панель администратора',
      headerTitleI18n: 'routes.adminPanel',
      headerLive: true,
    },
  },

  // Справочники (ТЗ «Рабочие задачи» блок 6.2–6.5) — доступ NZ / админ,
  // canAccessPath / canEdit разберутся сами через armAccess.
  {
    path: '/settings/ranks',
    name: 'settings-ranks',
    component: RanksSettingsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Справочник: Звания', headerTitleI18n: 'routes.dictRanks', headerLive: true },
  },
  {
    path: '/settings/positions',
    name: 'settings-positions',
    component: PositionsSettingsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Справочник: Должности', headerTitleI18n: 'routes.dictPositions', headerLive: true },
  },
  {
    path: '/settings/stpn-types',
    name: 'settings-stpn-types',
    component: StpnTypesSettingsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Справочник: СТПН', headerTitleI18n: 'routes.dictStpn', headerLive: true },
  },
  {
    path: '/settings/user-categories',
    name: 'settings-user-categories',
    component: UserCategoriesSettingsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Справочник: Категории военнослужащих', headerTitleI18n: 'routes.dictUserCat', headerLive: true },
  },
  {
    path: '/settings/vehicle-types',
    name: 'settings-vehicle-types',
    component: VehicleTypesSettingsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Справочник КПС: Типы ТС', headerTitleI18n: 'routes.dictVehicleTypes', headerLive: true },
  },
  {
    path: '/settings/meal-types',
    name: 'settings-meal-types',
    component: MealTypesSettingsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Справочник КПС: Типы питания', headerTitleI18n: 'routes.dictMealTypes', headerLive: true },
  },
  {
    path: '/settings/check-types',
    name: 'settings-check-types',
    component: CheckTypesSettingsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Справочник КПС: Виды проверок', headerTitleI18n: 'routes.dictCheckTypes', headerLive: true },
  },
  {
    path: '/settings/routine',
    name: 'settings-routine',
    component: RoutineSettingsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Типовой распорядок дня', headerTitleI18n: 'routes.routineTemplates', headerLive: true },
  },

  {
    path: '/chpo',
    redirect: '/',
  },
  {
    path: '/chpo/plan',
    name: 'plan',
    component: PlanView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: CHPO_TITLE,
      headerTitleI18n: CHPO_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/chpo/decision-start',
    name: 'decision-start',
    component: DecisionStartView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: CHPO_TITLE,
      headerTitleI18n: CHPO_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/chpo/personnel',
    name: 'personnel',
    component: PersonnelListView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: CHPO_TITLE,
      headerTitleI18n: CHPO_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/chpo/orders',
    name: 'orders',
    component: OrdersView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: CHPO_TITLE,
      headerTitleI18n: CHPO_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/map-scheme',
    name: 'map-scheme',
    component: MapSchemeView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: 'Схема участка',
      headerTitleI18n: 'routes.mapScheme',
      headerLive: true,
    },
  },
  {
    path: '/tsog',
    name: 'tsog',
    component: TsogView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: 'ТСОГ',
      headerTitleI18n: 'routes.tsog',
      headerLive: true,
    },
  },
  {
    path: '/chpo/map',
    name: 'map',
    component: MapView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: CHPO_TITLE,
      headerTitleI18n: CHPO_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/chpo/forces',
    name: 'forces',
    component: ForcesView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: CHPO_TITLE,
      headerTitleI18n: CHPO_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/chpo/brief',
    name: 'brief',
    component: BriefView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: CHPO_TITLE,
      headerTitleI18n: CHPO_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/chpo/daily-schedule',
    name: 'daily-schedule',
    component: DailyScheduleView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: CHPO_TITLE,
      headerTitleI18n: CHPO_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/chpo/sector-select',
    name: 'sector-select',
    component: SectorSelectView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: CHPO_TITLE,
      headerTitleI18n: CHPO_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/chpo/workload',
    name: 'workload',
    component: WorkloadView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: 'Лист нагрузки',
      headerTitleI18n: 'routes.chpoWorkload',
      headerLive: true,
    },
  },
  {
    path: '/kps/map',
    name: 'kps-map',
    component: KpsMapView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/personnel',
    name: 'kps-personnel',
    component: KpsPersonnelView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/orders',
    name: 'kps-orders',
    component: KpsOrdersView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/calendar',
    name: 'kps-calendar',
    component: KpsCalendarView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/section-4',
    name: 'kps-section-4',
    component: KpsCalendarView,
    props: { section: '4' },
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/section-5',
    name: 'kps-section-5',
    component: KpsCalendarView,
    props: { section: '5' },
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/section-6',
    name: 'kps-section-6',
    component: KpsCalendarView,
    props: { section: '6' },
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/officers-work',
    name: 'kps-officers-work',
    component: KpsOfficersWorkView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/inspections',
    name: 'kps-inspections',
    component: KpsInspectionsView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/dd-members',
    name: 'kps-dd-members',
    component: KpsDdMembersView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/plan-extract',
    name: 'kps-plan-extract',
    component: KpsPlanExtractView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/border-violations',
    name: 'kps-border-violations',
    component: KpsBorderViolationsView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/regime-violations',
    name: 'kps-regime-violations',
    component: KpsRegimeViolationsView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/border-regime-violations',
    name: 'kps-border-regime-violations',
    component: KpsBorderRegimeViolationsView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },
  {
    path: '/kps/guard-rules-violations',
    name: 'kps-guard-rules-violations',
    component: KpsGuardRulesViolationsView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: KPS_TITLE,
      headerTitleI18n: KPS_TITLE_I18N,
      headerLive: true,
    },
  },

  // Household routes
  /* {
    path: '/household/dashboard',
    name: 'household-dashboard',
    component: HouseholdDashboardView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household' },
  }, */
  // По ТЗ 10.09.2026: страницы 11 служб войскового хозяйства.
  // :code ∈ pfs|ovs|kes|gsm|svyaz|asu|rav|inzh|abts|vet|med.
  {
    path: '/household/services/:code',
    name: 'household-service',
    component: HouseholdWarehouseServicePage,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Склад службы', headerTitleI18n: 'routes.householdService' },
  },
  {
    path: '/household/nomenclature-types',
    name: 'household-nomenclature-types',
    component: HouseholdNomenclatureTypesView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household' },
  },
  {
    path: '/household/nomenclatures',
    name: 'household-nomenclatures',
    component: HouseholdNomenclaturesView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household' },
  },
  {
    path: '/household/counterparties',
    name: 'household-counterparties',
    component: HouseholdCounterpartiesView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household' },
  },
  {
    path: '/household/warehouses',
    name: 'household-warehouses',
    component: HouseholdWarehousesView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household' },
  },
  {
    path: '/household/receipt',
    name: 'household-receipt',
    component: HouseholdOperationsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household', type: 'receipt' },
  },
  {
    path: '/household/consumption',
    name: 'household-consumption',
    component: HouseholdOperationsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household', type: 'consumption' },
  },
  {
    path: '/household/movement',
    name: 'household-movement',
    component: HouseholdOperationsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household', type: 'movement' },
  },
  {
    path: '/household/writeoff',
    name: 'household-writeoff',
    component: HouseholdOperationsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household', type: 'writeoff' },
  },
  {
    path: '/household/inventory',
    name: 'household-inventory',
    component: HouseholdOperationsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household', type: 'inventory' },
  },
  {
    path: '/household/expiry',
    name: 'household-expiry',
    component: HouseholdExpiryView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household' },
  },
  {
    path: '/household/depreciation',
    name: 'household-depreciation',
    component: HouseholdDepreciationView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household' },
  },
  {
    path: '/household/temp-storage',
    name: 'household-temp-storage',
    component: HouseholdTempStorageView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household' },
  },
  {
    path: '/household/weapon-issue',
    name: 'household-weapon-issue',
    component: HouseholdWeaponIssueView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household' },
  },
  {
    path: '/household/stock-report',
    name: 'household-stock-report',
    component: HouseholdStockReportView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household' },
  },
  {
    path: '/household/movement-report',
    name: 'household-movement-report',
    component: HouseholdMovementReportView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household' },
  },
  {
    path: '/household/statements',
    name: 'household-statements',
    component: HouseholdStatementsView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'Воинское хозяйство', headerTitleI18n: 'routes.household' },
  },
  {
    path: '/mpo',
    name: 'mpo',
    component: MpoStarChartView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'МПО - Звездная карта', headerTitleI18n: 'routes.mpo' },
  },
  // БСФП routes
  {
    path: '/bsfp/attendance',
    name: 'bsfp-attendance',
    component: BsfpAttendanceView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'БСФП - Журнал посещений', headerTitleI18n: 'routes.bsfpAttendance' },
  },
  {
    path: '/bsfp/schedule',
    name: 'bsfp-schedule',
    component: BsfpScheduleView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'БСФП - План / расписание', headerTitleI18n: 'routes.bsfpSchedule' },
  },
  {
    path: '/bsfp/literature',
    name: 'bsfp-literature',
    component: BsfpLiteratureView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'БСФП - База данных литератору', headerTitleI18n: 'routes.bsfpLiterature' },
  },
  {
    path: '/kps/literature',
    name: 'kps-literature',
    component: BsfpLiteratureView,
    meta: { layout: 'default', middleware: [auth], headerTitle: KPS_TITLE, headerTitleI18n: KPS_TITLE_I18N },
  },
  // ВИР routes
  {
    path: '/vir/performance',
    name: 'vir-performance',
    component: VirPerformanceView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'ВИР - Успеваемости', headerTitleI18n: 'routes.virPerformance' },
  },
  {
    path: '/vir/schedule',
    name: 'vir-schedule',
    component: VirScheduleView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'ВИР - Расписание', headerTitleI18n: 'routes.virSchedule' },
  },
  {
    path: '/vir/literature',
    name: 'vir-literature',
    component: BsfpLiteratureView,
    meta: { layout: 'default', middleware: [auth], headerTitle: 'ВИР - База данных литератору', headerTitleI18n: 'routes.virLiterature' },
  },
  {
    path: '/admin/users',
    name: 'admin-users',
    component: AdminUsersView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: 'Управление пользователями',
      headerTitleI18n: 'routes.adminUsers',
      adminOnly: true,
    },
  },
  {
    path: '/admin/dictionaries',
    name: 'admin-dictionaries',
    component: AdminDictionariesView,
    meta: {
      layout: 'default',
      middleware: [auth],
      headerTitle: 'Справочники',
      headerTitleI18n: 'routes.adminDict',
      adminOnly: true,
    },
  },
  {
    // Публичный kiosk-режим прохождения соц. опроса — без авторизации.
    path: '/mpo/kiosk/:token',
    name: 'mpo-kiosk',
    component: KioskSurveyView,
    meta: {
      layout: 'blank',
      public: true,
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  const middleware = to.meta?.middleware
  if (!middleware || !Array.isArray(middleware) || middleware.length === 0) {
    return next()
  }
  return middleware[0](to, from, next)
})

// Guard выбора дат и инициализации контекста для /chpo/* и /kps/*
router.beforeEach(async (to, from, next) => {
  try {
    const now = new Date();

    if (to.path.startsWith('/chpo')) {
      const dateISO = computeChpoDate(now);
      await checkOrCreateChpoByDate(dateISO);
      to.meta.dateISO = dateISO; // для отображения в заголовке
    } else if (to.path.startsWith('/kps')) {
      // book -> текущий день (предыдущие доступны через календарь/выбор даты в самих разделах)
      const dateISO = computeBookDate(now);
      await checkOrCreateBookByDate(dateISO);
      to.meta.dateISO = dateISO;
    }
  } catch (e) {
    if (e?.status === 401) return next({ name: 'login' });
    // eslint-disable-next-line no-console
    console.error('Инициализация контекста (book/chpo) не удалась', e);
    // продолжим навигацию; http слой попытается сам
  }
  return next();
});

export default router
